import React from 'react';
import styled from 'styled-components';

import { useReadCoverLetter } from '@xing-com/crate-lebenslauf-hooks';

import { RENDERERS } from './cover-letter-editor';

const Block = styled.div`
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 10px;

  p,
  li {
    font-size: 10px;
    line-height: 15px;
    text-align: justify;
  }
`;

const textRenderer = ({ renderers, node }: any): any => {
  if (!node.type) {
    const nodeKeys = Object.keys(node);
    const nodeMarks = nodeKeys.filter((key) => node[key] === true);
    if (!nodeMarks || nodeMarks.length === 0) return node.text;

    return nodeMarks.reduce(
      (children, mark, key) =>
        renderBlock({
          renderers,
          node: { type: mark },
          nodeAttributes: { children, key },
        }) || children,
      node.text
    );
  }
};

const renderBlock = ({ renderers, node, nodeAttributes }: any): any => {
  let element;
  renderers.find(
    (renderer: any) => (element = renderer({ renderers, node, nodeAttributes }))
  );
  return element;
};

const renderBlocks = ({ renderers, nodes }: any): any =>
  nodes
    .map((node: any, key: any) => {
      const children =
        renderBlocks({ renderers, nodes: node.children || [] }) || null;

      const element = renderBlock({
        renderers,
        node,
        nodeAttributes: { children, key },
      });
      return element;
    })
    .filter((e: any) => !!e);

const getCoverLetterBlocks = (document: any): JSX.Element[] =>
  renderBlocks({
    renderers: [textRenderer, ...RENDERERS],
    nodes: document,
  });

export const useCoverLetterViewerBlocks = (): JSX.Element[] => {
  const [data, setData] = React.useState<JSX.Element[]>([]);
  const { content } = useReadCoverLetter();

  React.useEffect(() => {
    const items = getCoverLetterBlocks(content).map((block, index) => (
      <Block key={`block-${index}`}>{block}</Block>
    ));

    setData(items);
  }, [content]);

  return data;
};
